//const API_URL = "http://46.101.182.73/predictions/"
const API_URL = "https://backdjango.pridict.it/predictions/"
// const API_URL = "http://127.0.0.1:8000/predictions/"

export {API_URL}
